<template>
  <div class="app" :class="mode">
    <span v-if="$route.path !== '/'">
      <Sidebar v-if="role !== 'admin' && role !== 'supplier'" />
    </span>
    <div class="container-fluid pt-2" style="height: 100vh">
      <div class="" v-if="birthdays.length && $route.name !== 'login'">
        <i
          class="fas fa-circle-info float-end fs-3 anime"
          data-toggle="modal"
          data-target="#birthday"
        ></i>
      </div>
      <div
        id="main-card"
        :class="$route.name !== 'login' ? 'card shadow p-2 responsive' : ''"
      >
        <!-- :style="[
          this.$route.name == 'login' || role == 'admin' || role == 'supplier'
            ? { 'margin-left': '0' }
            : { 'margin-left': '35px' },
        ]" -->
        <div
          class="btn-group btn-group-sm btn-admin"
          v-if="
            (role == 'admin' &&
              $route.name !== 'login' &&
              $route.name !== 'main') ||
            (role == 'supplier' &&
              $route.name !== 'login' &&
              $route.name !== 'main')
          "
        >
          <button class="btn btn-outline-secondary" @click="back()">
            <i class="fa fa-arrow-left" />
          </button>
          <router-link to="/main" class="btn btn-outline-secondary">
            <i class="fa fa-home" />
          </router-link>
        </div>
        <Router-view @setloading="setloading" v-slot="{ Component, route }">
          <transition name="router" mode="out-in">
            <div :key="route">
              <component :is="Component"></component>
            </div>
          </transition>
        </Router-view>
      </div>
      <!-- <Notification v-if="role == 'branch_admin' && this.$route.name !== 'login'"/> -->
    </div>
    <div class="modal fade" id="birthday">
      <div class="modal-dialog modal-lg">
        <div class="modal-content px-2">
          <h3>Bu haftada tug'ilgan kuni bor mijozlar !</h3>
          <div style="height: 60vh; overflow-y: auto">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Ismi</th>
                  <th>Telefon raqami</th>
                  <th>Tug'ilgan kuni</th>
                  <th>Turi</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in birthdays" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>+998 {{ format(item.phone) }}</td>
                  <td>{{ item.birthday }}</td>
                  <td>
                    <i class="fa fa-user-tag" />
                    <span> {{ item.type }} </span>
                  </td>
                  <td>
                    <div class="row my-1 gap-1">
                      <div class="col">
                        <router-link
                          :to="`/mijoz/${item.id}`"
                          class="btn btn-sm btn-block btn-outline-info"
                        >
                          <span class="fa fa-info" />
                        </router-link>
                      </div>
                      <div class="col">
                        <button
                          class="btn btn-sm btn-block btn-outline-warning"
                          data-toggle="modal"
                          data-target="#editMijoz"
                          @click="editMijoz = item"
                        >
                          <span class="fas fa-edit" />
                        </button>
                      </div>
                      <div class="col">
                        <button
                          class="btn btn-sm btn-block btn-outline-warning"
                          @click="smsSubmit(item)"
                        >
                          <span class="fas fa-message" />
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editMijoz">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4>{{ editMijoz.name }} ma'lumotlarini tahrirlash</h4>
          </div>
          <form @submit.prevent="put(editMijoz)">
            <div class="modal-body">
              <div class="row gap-2">
                <div class="col-md-10 mx-auto">
                  Ism
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="ism"
                    required
                    v-model="editMijoz.name"
                  />
                </div>
                <div class="col-md-10 mx-auto">
                  Telefon raqam
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <div class="input-group-text">+998</div>
                    </div>
                    <input
                      class="form-control"
                      type="tel"
                      minlength="9"
                      maxlength="9"
                      placeholder="tel"
                      required
                      v-model="editMijoz.phone"
                    />
                  </div>
                </div>
                <div class="col-md-10 mx-auto">
                  Tug'ilgan sana
                  <input
                    class="form-control form-control-sm"
                    type="date"
                    required
                    v-model="editMijoz.birthday"
                  />
                </div>
                <div class="col-md-10 mx-auto">
                  Toifa
                  <select
                    class="form-select form-select-sm"
                    v-model="editMijoz.type"
                  >
                    <option value="Umumiy">Umumiy</option>
                    <option value="Qora ro'yxat">Qora ro'yxat</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary">
                <span class="far fa-circle-check" />
              </button>
              <button
                id="close-modal-birthday"
                class="btn btn-outline-danger"
                data-dismiss="modal"
              >
                <span class="far fa-circle-xmark" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <isloading v-if="loading" />
  </div>
</template>

<script>
import Sidebar from "./components/sidebar/Sidebar.vue";
import Notification from "./views/Notification/Notification.vue";
import swal from "sweetalert";
import isloading from "./components/Animation/Anime.vue";
import {
  catchError,
  customersBirthdaysWeek,
  updateCustomer,
  branch,
} from "./components/Api/Api";
export default {
  name: "App",
  components: { Sidebar, Notification, isloading },
  data() {
    return {
      role: localStorage.getItem("role"),
      mode: localStorage.getItem("mode"),
      branch_id: localStorage.getItem("branch_id"),
      loading: true,
      birthdays: [],
      editMijoz: {},
      branch: null,
    };
  },
  watch: {
    $route(to) {
      document.title = `Savdo • ${to.meta.title}`;
      this.loading = true;
      this.setDisplay();
    },
  },
  created() {
    this.setDisplay();
    setInterval(() => {
      window.onoffline = () => {
        swal({
          icon: "warning",
          title: "Tarmoq bilan aloqa mavjud emas !",
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      };
    }, 60000);
    window.ononline = () => {
      swal({
        icon: "success",
        title: "Aloqa mavjud !",
        timer: 1500,
      }).then(() => {});
    };
    if (localStorage.getItem("access_token")) {
      branch(this.branch_id)
        .then((res) => {
          this.branch = res.data;
        })
        .catch((error) => {
          catchError(error);
        });
      this.birthdaysWeek();
    }
  },
  mounted() {},
  methods: {
    smsSubmit(data) {
      let template = this.branch?.branch?.sms_text;
      let message = template.replace(/#(\w+)/g, (_, key) => data[key] || "");
      const phone = data.phone;
      const smsUrl = `sms:${phone}?body=${encodeURIComponent(message)}`;
      window.location.href = smsUrl;
    },
    format(number) {
      return String(
        "(" +
          String(number).substr(0, 2) +
          ") " +
          String(number).substr(2, 3) +
          " " +
          String(number).substr(5, 2) +
          " " +
          String(number).substr(7, 2)
      );
    },
    put(data) {
      this.$emit("setloading", true);
      updateCustomer(data)
        .then((Response) => {
          document.querySelector("#close-modal-birthday").click();
        })
        .catch((error) => {
          catchError(error);
        });
    },
    back() {
      this.$router.go(-1);
    },
    setloading(loading) {
      this.loading = loading;
    },
    setDisplay() {
      document.documentElement.style.setProperty(
        "--main-font",
        localStorage.getItem("main_font")
      );
      document.documentElement.style.setProperty(
        "--main-color",
        localStorage.getItem("main_color")
      );
      document.documentElement.style.setProperty(
        "--main-border",
        localStorage.getItem("main_color2")
      );
      document.documentElement.style.setProperty(
        "--main-logo",
        localStorage.getItem("main_logo")
      );
    },
    birthdaysWeek() {
      if (this.role !== "admin") {
        customersBirthdaysWeek()
          .then((res) => {
            this.birthdays = res.data;
          })
          .catch((error) => {
            catchError(error);
          });
      }
    },
  },
};
</script>

<style>
@import url("./main.css");
@import url("./dark.css");

.btn-admin {
  position: absolute;
  z-index: 10;
}

.router-enter-active {
  animation: routerIn 0.3s ease;
  transform-origin: top;
}

@keyframes routerIn {
  0% {
    transform: translate(100%, 0);
    /* transform: scale(0); */
  }

  /* 50% {
    transform: scale(1.1);
  } */
  100% {
    transform: translate(0, 0);
    /* transform: scale(1); */
  }
}

.router-leave-active {
  animation: routerOut 0.3s ease;
}

@keyframes routerOut {
  from {
    transform: translate(0, 0);
    /* transform: scale(1); */
  }

  to {
    transform: translate(100%, 0);
    /* transform: scale(0.9); */
  }
}

.anime {
  z-index: 10;
  position: relative;
  animation: infoButton 1s infinite;
  cursor: pointer;
}

@keyframes infoButton {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>

